import styled from 'styled-components';

/** Icon box matching homepage service cards */
const BrandIcon = styled.div`
  width: ${(p) => p.$size || 48}px;
  height: ${(p) => p.$size || 48}px;
  border-radius: ${(p) => p.$radius || 12}px;
  background: rgba(14, 107, 60, 0.04);
  border: 1.5px solid rgba(14, 107, 60, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: ${(p) => p.$iconSize || '1.15rem'};
    color: #0e6b3c;
  }
`;

export default BrandIcon;
